import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SiteLayout } from '../components/layout/SiteLayout';
import { useRedirect } from '../hooks/useRedirect';

export function NotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: redirect, isLoading } = useRedirect(location.pathname);

  useEffect(() => {
    if (!redirect) return;
    navigate(redirect.toPath, { replace: redirect.type === '301' });
  }, [redirect, navigate]);

  // While checking for redirect, show nothing (or a brief spinner)
  if (isLoading) return null;

  // If a redirect was found, useEffect handles navigation — render nothing
  if (redirect) return null;

  return (
    <SiteLayout>
      <div className="flex flex-col items-center justify-center py-24 text-center gap-6 px-4">
        <p className="text-7xl font-black text-zinc-100 select-none">404</p>
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-zinc-800">Page not found</h1>
          <p className="text-sm text-zinc-500 max-w-sm">
            The page you&apos;re looking for doesn&apos;t exist or may have moved.
          </p>
        </div>
        <button
          onClick={() => navigate('/')}
          className="px-5 py-2.5 rounded-xl bg-[var(--color-primary,#4F46E5)] text-white text-sm font-semibold hover:opacity-90 transition-opacity"
        >
          Go to homepage
        </button>
      </div>
    </SiteLayout>
  );
}
